import React from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import "./PortfolioCard.css";
import { Link } from "react-router-dom";

const PortfolioCard = (props) => {
  return (
    <div className="Portfolio-Card">
      <div className="Portfolio-Image-Wrapper">
        <img src={props.image} alt="" className="Portfolio-Image" />
      </div>
      <div className="Portfolio-Content">
        <h3 className="Title">{props.title}</h3>
        <p className="Description">{props.description}</p>
        <div className="Row">
          <a target="" href={props.link} className="Live">
            Live <FaArrowUpRightFromSquare />
          </a>
          <Link to={`/portfolio/${props.title}`}>
            <button className="Detail">Detail</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
